module.exports = __webpack_public_path__ + "static/media/inner_fabric.556c37e4.svg";